import { BaseReq, request } from '@paradigm/api/src/fetch-api';

export type SubscriptionStatus =
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'unpaid'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'paused';

export interface BillingCredits {
  readonly subscription: number;
  readonly purchased: number;
  readonly total: number;
}

export interface BillingSubscription {
  readonly status: SubscriptionStatus;
  readonly current_period_end?: string;
  readonly cancel_at_period_end?: boolean;
}

export interface BillingMe {
  readonly credits: BillingCredits;
  readonly subscription: BillingSubscription | null;
  readonly can_buy_credits: boolean;
}

export interface CreditPack {
  readonly price_id: string;
  readonly amount_usd: number;
  readonly name: string;
}

interface CreditPacksResp {
  readonly packs: readonly CreditPack[];
}

interface CheckoutResp {
  readonly checkout_url: string;
}

interface PortalResp {
  readonly portal_url: string;
}

export const getBillingMe = (req: BaseReq) =>
  request<BillingMe>({ ...req, method: 'GET', url: '/billing/me/' });

export const getCreditPacks = (req: BaseReq) =>
  request<CreditPacksResp>({
    ...req,
    method: 'GET',
    url: '/billing/credit-packs/',
  });

export const startSubscriptionCheckout = (req: BaseReq) =>
  request<CheckoutResp>({
    ...req,
    method: 'POST',
    url: '/billing/checkout/subscription/',
  });

interface StartCreditPackCheckoutReq extends BaseReq {
  readonly priceId: string;
}

export const startCreditPackCheckout = ({
  priceId,
  ...req
}: StartCreditPackCheckoutReq) =>
  request<CheckoutResp>({
    ...req,
    method: 'POST',
    url: '/billing/checkout/credit-pack/',
    body: { price_id: priceId },
  });

export const openBillingPortal = (req: BaseReq) =>
  request<PortalResp>({ ...req, method: 'POST', url: '/billing/portal/' });
